import React, { useEffect } from 'react';
// import axios from 'axios';
import DiceWebsocket from './DiceWebsocket';
import storageManager from '../utils/LocalStorageManager'
import { Button, Checkbox, FormControlLabel } from '@material-ui/core';
// import ChatList from './ChatList';
// import ChatBox from './ChatBox';
// import logo from './logo.svg';
// import './App.css';

export default function Websocket({ connected, setConnected }) {

  const connect = () => {
    const roomName = window.prompt('Sala: ', 'rpgkaiju')
    storageManager.setRoom(roomName)
    setConnected(true)
  }

  const disconnect = () => {
    storageManager.setRoom(null)
    setConnected(false)
  }

  const handleChange = () => {
    if (connected)
      disconnect()
    else
      connect()
  }

  return (
    <>
      {/* <Checkbox
        checked={connected}
        onChange={() => handleChange()}
        inputProps={{ 'aria-label': 'primary checkbox' }}
      /><h1>Connect</h1> */}
      <FormControlLabel
        control={
          <Checkbox
            checked={connected}
            onChange={() => handleChange()}
            inputProps={{ 'aria-label': 'primary checkbox' }}
          />
        }
        label="Connect"
      />
      {/* {connected ? <Checkbox disabled checked /> : <Checkbox disabled />} */}
      {/* <Button onClick={connect()}></Button> */}
      {/* <Button onClick={disconnect()}>Disconnect</Button> */}
      <DiceWebsocket connected={connected} />
    </>
  )
}